import { Typography, Stack } from '@mui/material';
import type { PropsWithChildren, ReactNode } from 'react';

export const NumericBulletSection = ({
  bulletNumber,
  title,
  titleInfo,
  titleAction,
  gap = '40px',
  children,
}: PropsWithChildren<{
  bulletNumber: number;
  title: string;
  titleInfo?: ReactNode;
  titleAction?: ReactNode;
  gap?: string;
}>) => {
  const heading = (
    <Stack direction='row' sx={{ alignItems: 'center', gap: '4px' }}>
      <Typography variant='h4'>{title}</Typography>
      {titleInfo}
    </Stack>
  );

  return (
    <Stack
      direction='row'
      sx={{
        gap: '24px',
        alignItems: 'start',
      }}
    >
      <Typography variant='h4'>{`${bulletNumber}.`}</Typography>
      <Stack
        sx={{
          width: '100%',
          // A flex item won't shrink below its content's min-content width, so a wide child such as a long code
          // line would otherwise push the section past its container instead of scrolling inside it.
          minWidth: 0,
          gap,
        }}
      >
        {titleAction ? (
          <Stack
            direction='row'
            sx={{
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px',
            }}
          >
            {heading}
            {titleAction}
          </Stack>
        ) : (
          heading
        )}
        {children}
      </Stack>
    </Stack>
  );
};
